export interface Coordinates {
  latitude: number;
  longitude: number;
}

export function formatCoordinatesTooltip(coordinates: Coordinates | null | undefined): string {
  return coordinates
    ? `${coordinates.latitude}, ${coordinates.longitude}`
    : 'Keine Koordinaten gesetzt';
}
